import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { IUser } from '@shared/models/login.model';

const BLACK_LIST = ['gp@ritewayautotransport.com'];

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate {
  private user: IUser;

  constructor(private router: Router) {}

  canActivate(): boolean {
    this.user = JSON.parse(localStorage.getItem('USER_DATA'));

    if (BLACK_LIST.includes(this.user.username)) {
      this.router.navigateByUrl('/main/orders');
    }

    return true;
  }
}
